import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import GroupForm from "components/Forms/GroupForm/GroupForm";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { getActions } from "app/features/actionsSlice";
import FormCard from "components/Forms/FormCard/FormCard";
import { Group } from "types";
import { createGroup } from "app/features/groupsSlice";
import withAuth from "lib/hoc/withAuth";

const GroupCreate = () => {
  const navigate = useNavigate();

  const [selectedActions, setSelectedActions] = useState<any[]>([]);

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getActions());
  }, []);

  const { actions } = useAppSelector((state) => state.actions);
  const { loading } = useAppSelector((state) => state.groups);

  const onCreateGroup = async (group: Group) => {
    await dispatch(createGroup(group));
    navigate("/admin/roles", { replace: false });
  };

  return (
    <FormCard maxWidthCard={775} maxWidthContainer='md' title='Nuevo Grupo'>
      <GroupForm
        loading={loading}
        actions={actions}
        handleSubmit={onCreateGroup}
        submitButtonText='Crear Grupo'
        selectedActions={selectedActions}
        setSelectedActions={setSelectedActions}
      />
    </FormCard>
  );
};

export default withAuth(GroupCreate);
